// TODO: Artikel in die Datenbank und via ner Kategorie auf Reparatur bestimmen
export const repairArticles = [
  {
    label: "S10001 - unrepariert zurück",
    value: "S10001",
  },
  {
    label: "W12001 - Turbine, Kugellager Service",
    value: "W12001",
  },
  {
    label: "W12002 - Turbine, Komplett Service",
    value: "W12002",
  },
  {
    label: "W12003 - Kopf Montage 1:1 (Blau) oder 4:1 (Grün), Kugellager Service",
    value: "W12003",
  },
  {
    label: "W12004 - Kopf Montage 1:1 (Blau) oder 4:1 (Grün), Komplett Service",
    value: "W12004",
  },
  {
    label: "W12005 - Winkelstück 1:1 (Blau) oder 4:1 (Grün), Kugellager Service",
    value: "W12005",
  },
  {
    label: "W12006 - Winkelstück 1:1 (Blau) oder 4:1 (Grün), Komplett Service",
    value: "W12006",
  },
  {
    label: "W12007 - Winkelstück 1:5 (Rot), Kugellager Service",
    value: "W12007",
  },
  {
    label: "W12011 - Mikromotor, Kugellager Service",
    value: "W12011",
  },
  {
    label: "W12013 - Winkelstück 1:5 (Rot), Komplett Service",
    value: "W12013",
  },
  {
    label: "W12014 - ZEG (luftbetrieben), Standard Service",
    value: "W12014",
  },
  {
    label: "W12015 - Schläuche, Komplett Service",
    value: "W12015",
  },
  {
    label: "W12016 - Laborhandstück, Kugellager Service",
    value: "W12016",
  },
  {
    label: "W12100 - Reparatur, Sonderfall",
    value: "W12100",
  },
  {
    label: "W13006 - ALTERNATIVANGEBOT: neuer blauer 1:1 INTRA Kopf",
    value: "W13006",
  },
  {
    label: "W13020 - ALTERNATIVANGEBOT: neues 1:1 INTRA LUX Gehäuse",
    value: "W13020",
  },
  {
    label: "W13000 - ALTERNATIVANGEBOT: neue Turbine",
    value: "W13000",
  },
  {
    label: "W13015 - ALTERNATIVANGEBOT: neues rotes 1:5 LUX-Winkelstück",
    value: "W13015",
  },
  {
    label: "W13011 - ALTERNATIVANGEBOT: neues blaues 1:1 LUX-Winkelstück",
    value: "W13011",
  },
  {
    label: "W13010 - ALTERNATIVANGEBOT: neues gerades 1:1 Handstück",
    value: "W13010",
  },
];

export const repairArticleToTitle = {
  S10001: "unrepariert zurück",
  W12001: "Turbine, Kugellager Service",
  W12002: "Turbine, Komplett Service",
  W12003: "Kopf Montage 1:1 (Blau) oder 4:1 (Grün), Kugellager Service",
  W12004: "Kopf Montage 1:1 (Blau) oder 4:1 (Grün), Komplett Service",
  W12005: "Winkelstück 1:1 (Blau) oder 4:1 (Grün), Kugellager Service",
  W12006: "Winkelstück 1:1 (Blau) oder 4:1 (Grün), Komplett Service",
  W12007: "Winkelstück 1:5 (Rot), Kugellager Service",
  W12011: "Mikromotor, Kugellager Service",
  W12013: "Winkelstück 1:5 (Rot), Komplett Service",
  W12014: "ZEG (luftbetrieben), Standard Service",
  W12015: "Schläuche, Komplett Service",
  W12016: "Laborhandstück, Kugellager Service",
  W12100: "Reparatur, Sonderfall",
  W13006:
    "Blauer 1:1 INTRA Kopf von Chirana, Modell 168D-T\nKompatibel mit blauem 1:1 INTRA LUX Gehäuse Chirana (W13020) oder Unterteile KaVo\nMade in EU\nMehr Infos unter https://winkelstueck-reparatur.de/product-category/hand-und-winkelstuecke/",
  W13020: `Blaues 1:1 INTRA Gehäuse mit Licht von Chirana, Modell 120L\nKompatibel mit blauem 1:1 INTRA Kopf Chirana (W13006) und allen ""KaVo INTRA“-Köpfen\nMade in EU\nMehr Infos unter https://winkelstueck-reparatur.de/product-category/hand-und-winkelstuecke/`,
  W13000: `Turbine mit Licht von Chirana, Modell TGL637AH\nMit Quick-Stop-Funktion (< 1 Sekunde)\n""Multiflex""- Kupplungssystem\n5-Düsen-Spray\nMade in EU\nMehr Infos unter https://winkelstueck-reparatur.de/product-category/hand-und-winkelstuecke/`,
  W13015: `Rotes 1:5 Winkelstück mit Licht von Chirana, Modell 120LR\n4-Düsen-Spray zur optimalen Kühlung\nMade in EU\nMehr Infos unter https://winkelstueck-reparatur.de/product-category/hand-und-winkelstuecke/`,
  W13011: `Blaues 1:1 Winkelstück mit Licht von Chirana, Modell 120LB\nFür Bohrer mit Ø 2,35mm\n4-Düsen-Spray zur optimalen Kühlung\nMade in EU\nMehr Infos unter https://winkelstueck-reparatur.de/product-category/hand-und-winkelstuecke/`,
  W13010: `Blaues 1:1 gerades Handstück von Chirana, Modell 110D\n1-Düsen-Spray\nMühelose Kontrolle des Spannsystems für Bohrer Ø 2,35mm\nMade in EU\nMehr Infos unter https://winkelstueck-reparatur.de/product-category/hand-und-winkelstuecke/`,
};

export const repairArticleToPrice = {
  S10001: {
    EUR: "0",
    CHF: "0",
  },
  W12001: {
    EUR: "12500",
    CHF: "14900",
  },
  W12002: {
    EUR: "19800",
    CHF: "22900",
  },
  W12003: {
    EUR: "9900",
    CHF: "11900",
  },
  W12004: {
    EUR: "15900",
    CHF: "18900",
  },
  W12005: {
    EUR: "15900",
    CHF: "18900",
  },
  W12006: {
    EUR: "21600",
    CHF: "25900",
  },
  W12007: {
    EUR: "16900",
    CHF: "19900",
  },
  W12011: {
    EUR: "21900",
    CHF: "25900",
  },
  W12013: {
    EUR: "29200",
    CHF: "34400",
  },
  W12014: {
    EUR: "19900",
    CHF: "23900",
  },
  W12015: {
    EUR: "19900",
    CHF: "23900",
  },
  W12016: {
    EUR: "25600",
    CHF: "29900",
  },
  W12100: {
    EUR: "0",
    CHF: "0",
  },
  W13006: {
    EUR: "16900",
    CHF: "17900",
  },
  W13020: {
    EUR: "25900",
    CHF: "26900",
  },
  W13000: {
    EUR: "36000",
    CHF: "37500",
  },
  W13015: {
    EUR: "38900",
    CHF: "39900",
  },
  W13011: {
    EUR: "27900",
    CHF: "29200",
  },
  W13010: {
    EUR: "21900",
    CHF: "23500",
  },
};
